import React from "react";
import SearchAndSelect from "../../../components/generic/search/SearchAndSelect";

const SelectTypeOfEvents = ({
  typesOfEventsSelected,
  setTypesOfEventsSelected,
  optionsList
}) => {

  return (
    <div className="event-type-select-wrapper">
      <div className="event-type-label">Event Types:</div>
      <SearchAndSelect
        mode="multiple"
        selectedValues={typesOfEventsSelected}
        placeholder="Click here to select event"
        setValue={setTypesOfEventsSelected}
        style={{
          width: "100%",
        }}
        options={optionsList}
        selectOptionType="Simple"
        noDebounceSearch={true}
      />
    </div>
  );
};

export default SelectTypeOfEvents;
